// Plain text fields are safe under React's default escaping.
// URL/resource fields need explicit scheme allowlisting and normalization.
export const WEBSITE_URL_ERROR = "Website URL must be a valid https:// URL.";

export function normalizeWebsiteUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) {
    return { value: null, error: null };
  }

  let url;
  try {
    url = new URL(raw);
  } catch {
    return { value: null, error: WEBSITE_URL_ERROR };
  }

  if (url.protocol !== "https:" || url.username || url.password) {
    return { value: null, error: WEBSITE_URL_ERROR };
  }

  return { value: url.toString(), error: null };
}

export function getRenderableWebsiteUrl(value) {
  return normalizeWebsiteUrl(value).value;
}
